import React, { useState } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import { getUserByPhoneApi } from '../../utils/apisConsts';
import UploadPaymentSlipsForm from './uploadPaymentSlipsForm';



export default function UploadUserPaymentSlips() {
    const [componentSteps] =useState([
        {
            title: 'Get User',
            content: <GetInfo apiLink={getUserByPhoneApi} />,
            id: 0,
        }, {
            title: 'Upload Documents',
            content: <UploadPaymentSlipsForm />,
            id: 1
        },
    ])

    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    )
}